<template>
  <div class="more_home">
    <headtop :headid="headid"></headtop>
    <div class="more_head">
      <h2>{{titles}}</h2>
      <!-- <p>Laws and regulations</p> -->
    </div>   
    <div class="details-back" @click="goback()">
          <img src="~@/assets/img/story/back.png" />
        </div>
    <div class="more_content">
        <div class="more_list" v-for="(item,index) in datalist" :key="index" @click="gotoDetails(item)">
          <p class="more_p1">{{item.title}}</p>
          <p class="more_p2">{{item.release_date}}</p>
        </div>
    </div> 
     <!-- 分页 -->
        <div class="pagin">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listform.page"
          :page-size="listform.rows"
          :total="total">
        </el-pagination>
        </div>
  </div>
</template>
<script>
import headtop from "@/components/Headtop.vue"
export default {
   components:{
    headtop,
  },
  data(){
    return{
      headid:'',
      datalist:[],
      listform:{
        page:1,
        rows:6,
        fk_menu_id:''
      },
      total:0,
      ids:'',
      titles:''
    }
  },
   mounted(){
    this.headid = this.$route.query.id
    this.listform.fk_menu_id = this.$route.query.fk_menu_id
    this.titles = this.$route.query.title
    this.getdatalist()
  },
  methods:{
    async getdatalist(){
      let res = await this.api.query('list_website_title_text',this.listform)
      if(res.data.status==true){
        this.datalist = res.data.data
        this.total = res.data.datax
      }
      console.log(res);
    },
    gotoDetails(item) {
        this.$router.push({
          path: '/storyDetails',
          query: {
            id: item.id,
            date: item.release_date
          }
        })
      },
    handleSizeChange(side){
      this.listform.page = 1
      this.listform.rows = side
      this.getdatalist()
    },
    handleCurrentChange(val){
      this.listform.page = val
      this.getdatalist()
    },
    goback(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.more_home{
  width: 100%;
  height: 900px;
  background: #F4F5F7;
  .more_head{
    width: 100%;
    margin: 0 auto;
    text-align: center;
    margin-top: 80px;
    h2{
      color: #517871;
    }
    p{
      color: #9AA6AF;
      margin-top: 10px;
    }
  }
  .details-back {
  cursor: pointer;
  width: 48px;
  height: 48px;
  background: #517871;
  opacity: 0.44;
  position: absolute;
  top: 151px;
  right: 209px;
  border-radius: 50%;
  text-align: center;
  img {
    width: 22px;
    height: 24px;
    margin-top: 11px;
  }
}
  .more_content{
    width: 100%;
    margin-top: 100px;
    .more_list{
      cursor: pointer;
      width: 100%;
      height: 70px;
      border-bottom: 1px dashed #B1B1B1;
      display: flex;
      justify-content: space-around;
      line-height: 70px;
      .more_p1{
        width: 600px;
        color: #000000;
        font-size: 16px;
      }
      .more_p2{
        color: #9AA6AF;
        font-size: 14px;
      }
    }
  }
  .pagin{
  width: 100%;
  margin-top: 60px;
  text-align: center;
}
.el-pagination li{
  background: #517871 !important;
}
}
</style>